(function () {
  'use strict';

  // 1) Bloquea peticiones de red hacia un dominio sospechoso detectado en el
  //    tema (funcion metafieldPoly en assets/main.js, linea ~2437: construye
  //    una URL caracter por caracter para evadir busquedas de texto, envia
  //    datos del visitante por POST y puede inyectar HTML arbitrario en la
  //    respuesta). No se edita ese archivo: se intercepta la peticion en la
  //    capa de red, asi se neutraliza sin tocar el JS obfuscado del tema.
  try {
    var blockedHost = 'cryingtheme.mars';
    var originalFetch = window.fetch ? window.fetch.bind(window) : null;
    if (originalFetch) {
      window.fetch = function (input, init) {
        try {
          var url = (typeof input === 'string') ? input : (input && input.url) || '';
          if (url.indexOf(blockedHost) !== -1) {
            console.warn('[seguridad] Peticion bloqueada hacia dominio no autorizado: ' + url);
            return Promise.resolve(new Response('{}', { status: 403, statusText: 'Blocked by security-fixes.js' }));
          }
        } catch (e) {}
        return originalFetch(input, init);
      };
    }
  } catch (e) {}

  // 2) Evita que la falta del icono del carrito (#cart-icon-bubble) en
  //    layouts alternativos (paginas armadas con GemPages, ej. NAILVE) rompa
  //    la inicializacion del <cart-drawer>. No cambia nada donde el icono SI
  //    existe (layout estandar): ahi el metodo original corre igual que
  //    siempre, solo que protegido con try/catch.
  try {
    var originalDefine = customElements.define.bind(customElements);
    customElements.define = function (name, Ctor, options) {
      try {
        if (name === 'cart-drawer' && Ctor && Ctor.prototype) {
          var fnName = 'setHeaderCartIconAccessibility';
          var original = Ctor.prototype[fnName];
          if (typeof original === 'function') {
            Ctor.prototype[fnName] = function () {
              try {
                return original.apply(this, arguments);
              } catch (e) {
                console.warn('[fix] cart-icon-bubble no existe en este layout; se omite sin romper la pagina.');
              }
            };
          }
        }
      } catch (e) {}
      return originalDefine(name, Ctor, options);
    };
  } catch (e) {}
})();
